import { useEffect } from "react";

const SITE_ORIGIN = "https://lightningflow.ai";
const DEFAULT_SOCIAL_IMAGE = "/platform/lightningflow-command-center-v9.png";

function upsertMeta(attribute, key, content) {
  if (!content) return;
  let tag = document.querySelector(`meta[${attribute}="${key}"]`);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attribute, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
}

export default function SEO({ title, description, canonicalPath, image, structuredData, noIndex = false }) {
  useEffect(() => {
    if (title) document.title = title;
    upsertMeta("name", "description", description);
    upsertMeta("property", "og:title", title);
    upsertMeta("property", "og:description", description);
    upsertMeta("property", "og:type", "website");
    upsertMeta("name", "robots", noIndex ? "noindex, nofollow" : "index, follow");
    upsertMeta("name", "twitter:card", image ? "summary_large_image" : "summary");
    upsertMeta("name", "twitter:title", title);
    upsertMeta("name", "twitter:description", description);

    const routePath = canonicalPath || window.location.pathname;
    const canonicalRoute = routePath === "/" ? "/" : `${routePath.replace(/\/$/, "")}/`;
    const canonicalUrl = new URL(canonicalRoute, SITE_ORIGIN).toString();
    const imageUrl = new URL(image || DEFAULT_SOCIAL_IMAGE, SITE_ORIGIN).toString();
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", canonicalUrl);
    upsertMeta("property", "og:url", canonicalUrl);
    upsertMeta("property", "og:site_name", "LightningFlow");
    upsertMeta("property", "og:image", imageUrl);
    upsertMeta("name", "twitter:image", imageUrl);

    const scriptId = "lf-page-structured-data";
    document.getElementById(scriptId)?.remove();
    if (structuredData) {
      const script = document.createElement("script");
      script.id = scriptId;
      script.type = "application/ld+json";
      script.text = JSON.stringify(structuredData);
      document.head.appendChild(script);
    }
  }, [title, description, canonicalPath, image, structuredData, noIndex]);
  return null;
}
